import React from "react";
import { experience, languages, aboutContent } from "../../data/content";
import { User, GlobeHemisphereWest } from "@phosphor-icons/react";

export const AboutSection: React.FC = () => {
  return (
    <section id="about" className="py-20 sm:py-24 border-b border-[#242320] scroll-mt-20 sm:scroll-mt-24">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        {/* Section Heading with Icon */}
        <div className="mb-10 sm:mb-12 text-left">
          <div className="flex items-center gap-2 mb-2">
            <User className="w-4 h-4 text-[#E5983A]" weight="bold" />
            <span className="text-xs font-mono uppercase tracking-widest text-[#E5983A]">
              {aboutContent.sectionTag}
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold font-display tracking-tight text-[#F3F2EE] mb-2">
            {aboutContent.title}
          </h2>
          <p className="text-xs font-mono text-[#8C8A84]">
            {aboutContent.subtitle}
          </p>
        </div>

        {/* Narrative Bio */}
        <div className="max-w-3xl space-y-6 text-[#A6A39A] text-base sm:text-lg leading-relaxed mb-12 sm:mb-14 text-left">
          {aboutContent.bioParagraphs.map((paragraph, idx) => (
            <p key={idx}>{paragraph}</p>
          ))}
        </div>

        {/* Experience & Languages Balanced Grid (Equal Width Boxes) */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-7 pt-8 border-t border-[#242320] text-left">
          {/* Experience Timeline */}
          <div className="flex flex-col space-y-3">
            <h3 className="text-xs font-mono uppercase tracking-widest text-[#8C8A84]">
              Experience History
            </h3>
            <div className="p-6 sm:p-7 rounded-2xl bg-[#181716] border border-[#2A2926] h-full flex flex-col justify-between space-y-4">
              <div>
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-1 mb-3">
                  <h4 className="text-base font-bold font-display text-[#F3F2EE]">
                    {experience[0]?.role || "Freelance Backend Developer"}
                  </h4>
                  <span className="text-xs font-mono text-[#E5983A]">
                    {experience[0]?.period || "2019 — Present"}
                  </span>
                </div>
                <ul className="space-y-2.5 text-sm text-[#A6A39A]">
                  {experience[0]?.points?.map((point, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <span className="text-[#E5983A] text-xs mt-1">›</span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Languages Spoken */}
          <div className="flex flex-col space-y-3">
            <h3 className="text-xs font-mono uppercase tracking-widest text-[#8C8A84]">
              Spoken Languages
            </h3>
            <div className="p-6 sm:p-7 rounded-2xl bg-[#181716] border border-[#2A2926] h-full flex flex-col justify-between space-y-3.5">
              <div className="flex items-center gap-2 text-xs font-mono text-[#E5983A] uppercase tracking-wider mb-2">
                <GlobeHemisphereWest size={16} />
                <span>Communication</span>
              </div>
              <div className="space-y-2.5">
                {languages.map((lang, idx) => (
                  <div
                    key={idx}
                    className="flex items-center justify-between py-2 border-b border-[#242320] last:border-b-0 text-sm"
                  >
                    <span className="text-[#F3F2EE] font-medium">{lang.name}</span>
                    <span className="text-xs font-mono text-[#8C8A84]">{lang.level}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
